import { render } from "./org-structure-select-box.vue?vue&type=template&id=7967f31e"
import script from "./org-structure-select-box.vue?vue&type=script&setup=true&lang=js"
export * from "./org-structure-select-box.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/nsi/components/forms/org-structure-form/org-structure-select-box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7967f31e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7967f31e', __exports__)) {
    api.reload('7967f31e', __exports__)
  }
  
  module.hot.accept("./org-structure-select-box.vue?vue&type=template&id=7967f31e", () => {
    api.rerender('7967f31e', render)
  })

}


export default __exports__